import type { BugSource } from '../../types';
import type { StatusChipColor } from '../../theme';

export const BUG_SOURCE_OPTIONS: BugSource[] = ['TEAM', 'CUSTOMER'];

export const BUG_SOURCE_COLOR: Record<BugSource, StatusChipColor> = {
  TEAM: 'default',
  CUSTOMER: 'warning',
};

/**
 * Nhãn nguồn phát hiện bug: TEAM luôn là "Alliance" (team nội bộ); CUSTOMER
 * dùng tên khách hàng thật của dự án (project.customer_name), rơi về nhãn
 * chung nếu dự án chưa đặt tên khách hàng.
 */
export function bugSourceLabel(source: BugSource, customerName?: string | null): string {
  if (source === 'TEAM') return 'Alliance';
  return customerName?.trim() || 'Khách hàng';
}

/** Dùng cho các màn không biết tên khách hàng của dự án (vd dropdown lọc). */
export const BUG_SOURCE_META: Record<BugSource, { label: string; color: StatusChipColor }> = {
  TEAM: { label: bugSourceLabel('TEAM'), color: BUG_SOURCE_COLOR.TEAM },
  CUSTOMER: { label: bugSourceLabel('CUSTOMER'), color: BUG_SOURCE_COLOR.CUSTOMER },
};
